import React, { useState, useEffect } from "react";
import ParagraphTag from "../../../reusebale/Paragraph";
import ImageTag from "../../../reusebale/imageTag";
import ReactPaginate from "react-paginate";
import NoData from "../../../reusebale/noData";
import Myloader from "../../../reusebale/MyLoader";
import db from "../../../../db/index.json";
import {
  Plus,
  ArrowUpDown,
  ArrowDownUp,
  Clock4,
  CircleAlert,
  CircleCheck,
  ArrowRight,
} from "lucide-react";
import BaseUrl from "../../../../constants/BaseUrl";
import { useSelector, useDispatch } from "react-redux";
import * as DataAction from "../../../../store/actions/data/DataAction";
import { useNavigate } from "react-router-dom"; // Import useNavigate
import { convertUTCDateToLocal } from "../../../../utils/utils";

const PreviousShift = ({ onViewDetails, selectedStaff }) => {
  const { support } = db;
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const [record, setAllRecord] = useState([]);
  const { loginSuccess } = useSelector((state) => state.auth);

  const GetAllPreviousShift = () => {
    const myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");
    myHeaders.append("Authorization", `Bearer ${loginSuccess?.token}`);
    const requestOptions = {
      method: "GET",
      headers: myHeaders,
      redirect: "follow",
    };

    fetch(
      `${BaseUrl}api/support/getShiftsByUserId/${selectedStaff?._id}`,
      requestOptions
    )
      .then((response) => response.json())
      .then((result) => {
        if (result.status === "Success") {
          setAllRecord(result.data);
        }
      })
      .catch((error) => console.error(error));
  };

  useEffect(() => {
    GetAllPreviousShift();
  }, []);

  function convertDate(oDateTime) {
    let aDate = oDateTime?.split("T");
    let time = aDate[1] ? aDate[1] : null;
    let finalDate = "";
    let aTime = time?.split(".")[0]?.split(":");

    if (Number(aTime[0]) > 12) {
      time = Number(aTime[0]) - 12 + ":" + aTime[1] + " PM";
    } else {
      time = aTime[0] + ":" + aTime[1] + " AM";
    }

    finalDate = `${time}`;
    return finalDate;
  }

  function getTimeDifference(checkInDate, checkOutDate) {
    const checkIn = new Date(checkInDate);
    const checkOut = new Date(checkOutDate);

    let diffInMinutes = Math.floor((checkOut - checkIn) / 60000); // Convert ms to minutes
    let hours = Math.floor(diffInMinutes / 60);
    let minutes = diffInMinutes % 60;

    return `${hours}hr : ${minutes}min`;
  }

  const [AllAllRequest, setAllResuests] = useState([
    {
      id: 1,
      shiftId: "MRID-001238",
      shiftName: "Broken light",
      propId: "PID-000199581",
      propName: "1949 Linda Street",
      cost: "$699.87",
      priority: "High Priority",
      status: "Active",
    },
    {
      id: 1,
      shiftId: "MRID-001238",
      shiftName: "Broken light",
      propId: "PID-000199581",
      propName: "1949 Linda Street",
      cost: "$699.87",
      priority: "High Priority",
      status: "Completed",
    },
    {
      id: 1,
      shiftId: "MRID-001238",
      shiftName: "Broken light",
      propId: "PID-000199581",
      propName: "1949 Linda Street",
      cost: "$699.87",
      priority: "High Priority",
      status: "Parts Ordered",
    },
    {
      id: 1,
      shiftId: "MRID-001238",
      shiftName: "Broken light",
      propId: "PID-000199581",
      propName: "1949 Linda Street",
      cost: "$699.87",
      priority: "High Priority",
      status: "Active",
    },
    {
      id: 1,
      shiftId: "MRID-001238",
      shiftName: "Broken light",
      propId: "PID-000199581",
      propName: "1949 Linda Street",
      cost: "$699.87",
      priority: "High Priority",
      status: "Parts Ordered",
    },
    {
      id: 1,
      shiftId: "MRID-001238",
      shiftName: "Broken light",
      propId: "PID-000199581",
      propName: "1949 Linda Street",
      cost: "$699.87",
      priority: "High Priority",
      status: "Completed",
    },
    {
      id: 1,
      shiftId: "MRID-001238",
      shiftName: "Broken light",
      propId: "PID-000199581",
      propName: "1949 Linda Street",
      cost: "$699.87",
      priority: "High Priority",
      status: "Active",
    },
    {
      id: 1,
      shiftId: "MRID-001238",
      shiftName: "Broken light",
      propId: "PID-000199581",
      propName: "1949 Linda Street",
      cost: "$699.87",
      priority: "High Priority",
      status: "Completed",
    },
    {
      id: 1,
      shiftId: "MRID-001238",
      shiftName: "Broken light",
      propId: "PID-000199581",
      propName: "1949 Linda Street",
      cost: "$699.87",
      priority: "High Priority",
      status: "Parts Ordered",
    },
    {
      id: 1,
      shiftId: "MRID-001238",
      shiftName: "Broken light",
      propId: "PID-000199581",
      propName: "1949 Linda Street",
      cost: "$699.87",
      priority: "High Priority",
      status: "Active",
    },
  ]);
  const [Loading, setLoading] = useState(false);

  // State for sorting
  const [sortConfig, setSortConfig] = useState({
    key: "lease",
    direction: "asc",
  });

  const requestSort = (key) => {
    let direction = "asc";
    if (sortConfig.key === key && sortConfig.direction === "asc") {
      direction = "desc";
    }
    setSortConfig({ key, direction });
    const sortedData = [...AllAllRequest].sort((a, b) => {
      if (a[key] < b[key]) {
        return direction === "asc" ? -1 : 1;
      }
      if (a[key] > b[key]) {
        return direction === "asc" ? 1 : -1;
      }
      return 0;
    });
    setAllResuests(sortedData);
  };

  return (
    <div className="h-[450px] pt-5">
      <div className="bg-white w-full rounded-xl h-[95%]">
        <div className="w-[95%] mx-auto h-full">
          <div className="flex items-center h-[15%]">
            <ParagraphTag
              content="Past Previous Shifts"
              classes="text-darkColor font-popinsSemiBold text-base pl-2 pt-2"
            />
          </div>
          <div className="overflow-x-scroll w-full h-[85%] panelScroll pt-2">
            <table className="w-full ">
              <thead className="sticky top-0 bg-white">
                <tr className="border-b border-black/20">
                  <th className="w-[25%] text-left pb-2">
                    <span className="flex">
                      <ParagraphTag
                        content={support.shiftThead1}
                        classes="text-darkColor/40 font-popinsSemiBold text-xs pr-1"
                      />
                      {sortConfig.key === "lease" ? (
                        sortConfig.direction === "asc" ? (
                          <ArrowUpDown
                            className="cursor-pointer"
                            size={13}
                            color="#6F6F6F"
                            onClick={() => requestSort("lease")}
                          />
                        ) : (
                          <ArrowDownUp
                            className="cursor-pointer"
                            size={13}
                            color="#6F6F6F"
                            onClick={() => requestSort("lease")}
                          />
                        )
                      ) : (
                        <ArrowUpDown
                          className="cursor-pointer"
                          size={13}
                          color="#6F6F6F"
                          onClick={() => requestSort("lease")}
                        />
                      )}
                    </span>
                  </th>
                  <th className="w-[12%] pb-2">
                    <span className="flex justify-center">
                      <ParagraphTag
                        content={support.shiftThead2}
                        classes="text-darkColor/40 font-popinsSemiBold text-xs pr-1"
                      />
                      {sortConfig.key === "status" ? (
                        sortConfig.direction === "asc" ? (
                          <ArrowUpDown
                            className="cursor-pointer"
                            size={13}
                            color="#6F6F6F"
                            onClick={() => requestSort("status")}
                          />
                        ) : (
                          <ArrowDownUp
                            className="cursor-pointer"
                            size={13}
                            color="#6F6F6F"
                            onClick={() => requestSort("status")}
                          />
                        )
                      ) : (
                        <ArrowUpDown
                          className="cursor-pointer"
                          size={13}
                          color="#6F6F6F"
                          onClick={() => requestSort("status")}
                        />
                      )}
                    </span>
                  </th>
                  <th className="w-[22%] pb-2">
                    <span className="flex justify-center">
                      <ParagraphTag
                        content={support.shiftThead3}
                        classes="text-darkColor/40 font-popinsSemiBold text-xs pr-1"
                      />
                      {sortConfig.key === "propertyInfo?.propertyName" ? (
                        sortConfig.direction === "asc" ? (
                          <ArrowUpDown
                            className="cursor-pointer"
                            size={13}
                            color="#6F6F6F"
                            onClick={() =>
                              requestSort("propertyInfo?.propertyName")
                            }
                          />
                        ) : (
                          <ArrowDownUp
                            className="cursor-pointer"
                            size={13}
                            color="#6F6F6F"
                            onClick={() =>
                              requestSort("propertyInfo?.propertyName")
                            }
                          />
                        )
                      ) : (
                        <ArrowUpDown
                          className="cursor-pointer"
                          size={13}
                          color="#6F6F6F"
                          onClick={() =>
                            requestSort("propertyInfo?.propertyName")
                          }
                        />
                      )}
                    </span>
                  </th>
                  <th className="w-[15%] pb-2">
                    <span className="flex justify-center">
                      <ParagraphTag
                        content={support.shiftThead4}
                        classes="text-darkColor/40 font-popinsSemiBold text-xs pl-2"
                      />
                      {sortConfig.key === "date" ? (
                        sortConfig.direction === "asc" ? (
                          <ArrowUpDown
                            className="cursor-pointer"
                            size={13}
                            color="#6F6F6F"
                            onClick={() => requestSort("date")}
                          />
                        ) : (
                          <ArrowDownUp
                            className="cursor-pointer"
                            size={13}
                            color="#6F6F6F"
                            onClick={() => requestSort("date")}
                          />
                        )
                      ) : (
                        <ArrowUpDown
                          className="cursor-pointer"
                          size={13}
                          color="#6F6F6F"
                          onClick={() => requestSort("date")}
                        />
                      )}
                    </span>
                  </th>
                  <th className="w-[13%] pb-2">
                    <span className="flex justify-center">
                      <ParagraphTag
                        content={support.shiftThead5}
                        classes="text-darkColor/40 font-popinsSemiBold text-xs pl-2"
                      />
                      {sortConfig.key === "dueDate" ? (
                        sortConfig.direction === "asc" ? (
                          <ArrowUpDown
                            className="cursor-pointer"
                            size={13}
                            color="#6F6F6F"
                            onClick={() => requestSort("dueDate")}
                          />
                        ) : (
                          <ArrowDownUp
                            className="cursor-pointer"
                            size={13}
                            color="#6F6F6F"
                            onClick={() => requestSort("dueDate")}
                          />
                        )
                      ) : (
                        <ArrowUpDown
                          className="cursor-pointer"
                          size={13}
                          color="#6F6F6F"
                          onClick={() => requestSort("dueDate")}
                        />
                      )}
                    </span>
                  </th>
                  <th className="w-[13%] text-right pr-4 pb-2">
                    <ParagraphTag
                      content={support.shiftThead6}
                      classes="text-darkColor/40 font-popinsSemiBold text-xs"
                    />
                  </th>
                </tr>
              </thead>
              <tbody>
                {record?.map((item) => (
                  <tr
                    key={item?._id}
                    className="hover:bg-gray-100 rounded-md cursor-pointer"
                  >
                    <td className="py-2">
                      <div className="flex items-center justify-between">
                        <div className="w-[18%] rounded-full">
                          <ImageTag
                            path="/assets/daashboard/setting-icon.png"
                            classes="w-full"
                            altText="logo"
                          />
                        </div>
                        <div className="w-[78%] cursor-pointer">
                          <ParagraphTag
                            content={`SHIFT-${(item?._id).slice(0, 10)}`}
                            classes="text-darkColor/50 font-popinsMedium text-xs"
                          />
                          <ParagraphTag
                            content={item?.shiftDate}
                            classes="text-darkColor font-popinsSemiBold text-sm"
                          />
                        </div>
                      </div>
                    </td>
                    <td className="py-2 font-popinsMedium text-darkColor text-sm">
                      <div className="flex justify-center items-center">
                        <span>
                          {(() => {
                            switch (item.status) {
                              case "Active":
                                return (
                                  <CircleAlert color="#E43B3B" size={20} />
                                );
                              case "Parts Ordered":
                                return <Clock4 color={"#FF814E"} size={20} />;
                              case "Completed":
                                return (
                                  <CircleCheck color="#01CB78" size={20} />
                                );
                              default:
                                break;
                            }
                          })()}
                        </span>
                        <span
                          className={`pl-2 ${
                            item.status === "Parts Ordered"
                              ? "text-themeColor"
                              : item.status === "In Progress"
                              ? "text-lightgray"
                              : "text-[#01CB78]"
                          }`}
                        >
                          {convertUTCDateToLocal(item?.checkInDate)}
                        </span>
                      </div>
                    </td>
                    <td className="py-2 px-4 font-popinsMedium text-darkColor text-sm text-center">
                      <div className="flex flex-col">
                        <span className="text-darkColor/50 text-xs">
                          {item?.propId}
                        </span>
                        <span className="text-sm text-darkColor">
                          {item?.checkOutDate
                            ? convertUTCDateToLocal(item?.checkOutDate)
                            : "Missing Checkout"}
                        </span>
                      </div>
                    </td>
                    <td className="py-2 px-4 font-popinsMedium text-darkColor text-sm text-center">
                      {item?.checkOutDate
                        ? getTimeDifference(
                            item?.checkInDate,
                            item?.checkOutDate
                          )
                        : "Not found"}
                    </td>
                    <td className="py-2 px-4 font-popinsMedium text-darkColor text-sm text-center">
                      {item?.numberOfActiveChats}
                    </td>
                    <td className="pt-5 2xl:pt-4 px-4 flex justify-end items-center h-full pr-8">
                      <div
                        onClick={() => {
                          navigate("/shift-detail");
                          dispatch(
                            DataAction.SelectedPrevSessionIdAction(item._id)
                          );
                        }}
                        className="flex justify-center items-center border border-themeColor w-7 h-7 rounded-md cursor-pointer"
                      >
                        <ArrowRight color="#6F6F6F" size={18} strokeWidth={2} />
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
            {Loading && (
              <div className="flex justify-center items-center w-full mt-20">
                <Myloader />
              </div>
            )}
            {record.length === 0 && !Loading && (
              <div className="w-full mt-5">
                <NoData />
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default PreviousShift;
